export const SEMI_FONT_FAMILY =
  // eslint-disable-next-line max-len
  'Inter,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif';

export const THEME_MODE_ATTRIBUTE = 'theme-mode';
